var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('Menu'),(_vm.isLoggedIn)?_c('div',{staticClass:"right"},[_c('Logotype'),_c('Social'),_c('Wallet'),_c('Profile')],1):_c('div',{staticClass:"right"},[_c('Logotype'),_c('Social'),_c('Auth')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }